// extracted by mini-css-extract-plugin
module.exports = {"container":"MTooltip_container__kGq-o","container__text":"MTooltip_container__text__1zEDp"};